import React, { useContext, useEffect, useState } from 'react';
import { FormDataContext } from '../../contexts/FormDataContext';
import { Box, Button, CircularProgress, Fade } from '@mui/material';
import axios from 'axios';
import { Email } from '../Email';
import { EmailInitial } from '../EmailInitial';
import { VARIANT_INITIAL } from '../IntakeComponent';

const ACCOUNT_SUBMIT_URL = '/roa/intake/account/submit';

const STATUS_EMAIL_ERROR = 'EMAIL_ERROR';
const STATUS_ACCOUNT_EXISTS = 'ACCOUNT_EXISTS';
// const STATUS_INVALID_DATA_ERROR = 'INVALID_DATA_ERROR';
// const STATUS_SERVER_ERROR = 'SERVER_ERROR';
const STATUS_SUCCESS = 'SUCCESS';
const STATUS_CONTINUATION = 'CONTINUATION';

export const AccountForm = ({intakeVariant}) => {
  const [isAccountExists, setIsAccountExists] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    currentUserEmail,
    setCurrentUserEmail,
    email,
    intakeDataLoaded,
    setPreferencesFormDisabled,
    fetchIntakeData,
    setIsFormDataLoaded,
  } = useContext(FormDataContext);

  const getFormObject = () => {
    const formObject = {
      email: email
    };
    const urlParams = new URLSearchParams(window.location.search);
    const eid = urlParams.get('eid');
    if (eid) {
        formObject.eid = eid;
    }
    return formObject;
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!email) {
      setEmailErrorMessage("Email address is a required field.");
      return;
    }
    setSubmitLoading(true);
    setIsAccountExists(false);
    setEmailErrorMessage('');
    try {
      // await new Promise((resolve) => setTimeout(resolve, 1500));
      const response = await axios.post(ACCOUNT_SUBMIT_URL, getFormObject());
      const submitResponseData = response.data;
      const responseStatus = submitResponseData.status;
      switch (responseStatus) {
        case STATUS_EMAIL_ERROR:
          setEmailErrorMessage(submitResponseData.message);
          break;
        case STATUS_ACCOUNT_EXISTS:
          setIsAccountExists(true);
          break;
        case STATUS_SUCCESS:
          setCurrentUserEmail(email);
          setPreferencesFormDisabled(false);
          break;
        case STATUS_CONTINUATION:
          setIsFormDataLoaded(false);
          await fetchIntakeData();
          setCurrentUserEmail(email);
          setIsFormDataLoaded(true);
          setPreferencesFormDisabled(false);
          break;
        default:
          setEmailErrorMessage('An error occurred saving your email address. Please try again.')
          break;
      }
    } catch (error) {
      console.error("Submit failed - an error occurred:", error);
      setEmailErrorMessage('A server error has occurred.  Please try again.')
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
      {
        intakeVariant === VARIANT_INITIAL
          ?
          <EmailInitial
            errorMessage={emailErrorMessage}
            isAccountExists={isAccountExists}
          />
          :
          <Email
            errorMessage={emailErrorMessage}
            isAccountExists={isAccountExists}
          />
      }
      {intakeDataLoaded && !currentUserEmail &&
        <Box align="center" sx={{marginTop: '8px'}}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{padding: '12px 50px'}}
            disabled={submitLoading}
            startIcon={submitLoading ? <CircularProgress size={24} color="inherit" /> : null}
          >
            {submitLoading ? 'Saving email address...' : 'Continue'}
          </Button>
        </Box>
      }
    </Box>
  )
};